export default __webpack_public_path__ + "assets/images/checked-lang-3247854e.png";